export const radius = {
  xs: 4, // 4px
  s: 8, // 8px
  m: 16, // 16px
  l: 80, // 80px
  xl: 100, // 100px
  full: 9999, // for button with pill apparance
};

export default radius;
